<div class="no-data dash-box bg-card-3">
  <lottie-player *ngIf="randomLottie" [src]="randomLottie" background="transparent" speed="2" loop autoplay>
  </lottie-player>

  <span *ngIf="data.text" class="txt">{{ data.text | translate }}</span>

  <button *ngIf="data.buttonText" mat-flat-button color="primary" class="foreground-8 il" (click)="onEmitAction()">
    <mat-icon>add</mat-icon>
    {{ data.buttonText | translate }}
  </button>
</div>